import { Link, Meta } from '@/@types/Pagination';
import { api } from './api';
import {
  ActiveSecretOrderBumpData,
  OrderBump,
} from '@/pages/EditProduct/Orderbumps/hooks/useOrderBumps.ts';
import { CreateOrderBumpData } from '@/pages/EditProduct/Orderbumps/hooks/useOrderBumps.ts';

interface UpdateOrderBumpData extends Partial<CreateOrderBumpData> {
  status?: 'active' | 'inactive';
}

interface OrderBumpResponse {
  data: OrderBump;
}

export interface OrderBumpsResponse {
  data: OrderBump[];
  meta: Meta;
  links: Link;
}

async function listOrderBumps(productId: string) {
  const response = await api.get<OrderBumpsResponse>(
    `/v1/products/${productId}/offer-bumps`
  );
  return response.data;
}

async function createOrderBump({
  productId,
  data,
}: {
  productId: string;
  data: CreateOrderBumpData;
}): Promise<OrderBump> {
  const response = await api.post<OrderBumpResponse>(
    `/v1/products/${productId}/offer-bumps`,
    data
  );
  return response.data.data;
}

async function updateOrderBump({
  productId,
  orderBumpId,
  data,
}: {
  productId: string;
  orderBumpId: string;
  data: UpdateOrderBumpData;
}): Promise<OrderBump> {
  const response = await api.put<OrderBumpResponse>(
    `/v1/products/${productId}/offer-bumps/${orderBumpId}`,
    data
  );
  return response.data.data;
}

async function viewOrderBump({
  productId,
  orderBumpId,
}: {
  productId: string;
  orderBumpId: string;
}) {
  const response = await api.get<OrderBumpResponse>(
    `/v1/products/${productId}/offer-bumps/${orderBumpId}`
  );
  return response.data.data;
}

async function deleteOrderBump({
  productId,
  orderBumpId,
}: {
  productId: string;
  orderBumpId: string;
}): Promise<void> {
  await api.delete(`/v1/products/${productId}/offer-bumps/${orderBumpId}`);
}

async function reorderOrderBumps({
  productId,
  orderBumpIds,
}: {
  productId: string;
  orderBumpIds: string[];
}): Promise<void> {
  await api.put(`/v1/products/${productId}/offer-bumps/reorder`, {
    data: { order_bump_ids: orderBumpIds },
  });
}

async function activateScretOrderBump(
  productId: string,
  data: ActiveSecretOrderBumpData
): Promise<void> {
  await api.post(`/v1/products/${productId}/secret-order-bump`, data);
}

export const OrderBumpService = {
  listOrderBumps,
  createOrderBump,
  updateOrderBump,
  viewOrderBump,
  deleteOrderBump,
  reorderOrderBumps,
  activateScretOrderBump,
};
